import AppConstants from '../constants/AppConstants';

export const initialState = {
    modalIsVisible: false,
    loading: false,
    data: {}
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.POSTBACK_TEST_MODAL_VISIBLE:
            return {
                ...state,
                modalIsVisible: true
            };

        case AppConstants.POSTBACK_TEST_MODAL_HIDDEN:
            return {
                ...state,
                modalIsVisible: false
            };

        case AppConstants.POSTBACK_TEST_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.POSTBACK_TEST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.items
            };

        case AppConstants.POSTBACK_TEST_CLEAR:
            return {
                ...state,
                ...initialState
            };

        default:
            return state;
    }
};
